import { JSX, useMemo, useState } from "react";

import { GeoJSON, Pane, useMap, useMapEvents } from "react-leaflet";

import { leafletFlowMapEventMap } from "./FileFlowMapLayer.helpers";
import { getFlowMapMaxCount } from "../../../../lib/number.helpers";
import { type FlowMapFeatureCollection } from "../../../../types/FlowMapFeatureCollection";

const styles = {
  FlowMapPane: { zIndex: 20 },
};

interface FileFlowMapLayerParams {
  flowMapRoutes: FlowMapFeatureCollection;
  thicknessFunction: (freq: number, maxFrequency: number, zoomMultiplicator: number) => number;
  coloringFunction: (freq: number, maxFrequency: number) => string;
}

function FileFlowMapLayer({ flowMapRoutes, thicknessFunction, coloringFunction }: FileFlowMapLayerParams): JSX.Element | null {
  const map = useMap();
  const [zoomLevel, setZoomLevel] = useState<number>(map.getZoom());
  const zoomMultiplicator = useMemo(() => zoomLevel ** 2.2 / 1000, [zoomLevel]);

  const mapEvents = useMapEvents({
    zoomend: () => {
      setZoomLevel(mapEvents.getZoom());
    },
  });

  const maxFrequency: number = useMemo(() => getFlowMapMaxCount(flowMapRoutes), [flowMapRoutes]);

  if (flowMapRoutes.features.length === 0) return null;

  return (
    <Pane name='File-flowMap-pane' style={styles.FlowMapPane}>
      <GeoJSON
        key={`${zoomLevel}-file-flowmap-pane`}
        data={flowMapRoutes}
        style={(feature) => {
          if (!feature) return {};
          return {
            stroke: true,
            color: coloringFunction(feature.properties.frequency, maxFrequency),
            weight: thicknessFunction(feature.properties.frequency, maxFrequency, zoomMultiplicator),
          };
        }}
        eventHandlers={leafletFlowMapEventMap()}
      />
    </Pane>
  );
}

export default FileFlowMapLayer;
